/*! Copyright (C) 2019 Cryptomathic A/S.
 *
 * Unless explicitly stated otherwise for a unit of code.
 */
namespace Cryptomathic.SignerUserSDK {
  export const copyright="Copyright (C) 2019 Cryptomathic A/S.";
}
